/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
/* global gettext */
import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import {
  USERS, USER_ROLES, DELETE_FROM_COLLECTION,
} from 'actions/collections';
import PropTypes from 'prop-types';
import { searchUsers } from 'actions/asyncActions';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Redirect } from 'react-router-dom';

export class SearchUsersPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fname: '',
      lname: '',
      email: '',
      redirect: false,
    };
    this.handleInput = this.handleInput.bind(this);
    this.evalInputs = this.evalInputs.bind(this);
    this.refineUserList = this.refineUserList.bind(this);
    this.currentUsersRole = this.currentUsersRole.bind(this);
    this.redirectUser = this.redirectUser.bind(this);
  }

  componentWillMount() {
    this.currentUsersRole();
    if (this.props.userPrivy !== 'GLOBAL_ADMIN') {
      this.setState({
        redirect: true,
      });
    }
  }


  currentUsersRole() {
    if (this.props.userPrivy.get('is_superuser') === false) {
      this.props.userPrivy = this.props.userPrivy.get('role')
        .get('id');
    } else {
      this.props.userPrivy = 'GLOBAL_ADMIN';
    }

    return this.props.userPrivy;
  }
  /*eslint-disable */
  redirectUser() {
    if (this.state.redirect) {
      return <Redirect to="/"/>;
    }
  }

  evalInputs() {
    const fName = this.state.fname;
    const lName = this.state.lname;
    const eMail = this.state.email;

    if (fName.length === 0 && lName.length === 0 && eMail.length === 0) {
      /*eslint-disable */
      alert('Please provide input in at least 1 field to make a search');
      return false;
    }

    this.props.searchUsers(fName, lName, eMail);
    return true;
  }

  refineUserList(arr) {
    let sites = [];
    arr.forEach((val, i) => {
      let theDot = val.indexOf('.');
      val = theDot !== -1 ? val.substring(0, theDot) : val;
      sites.push(val);
    });

    return sites;
  }

  handleInput(e) {
    const inputElem = e.target.className;
    const inputVal = e.target.value;
    this.setState({
      [inputElem]: inputVal,
    });
  }

  render() {
    const usersLoaded = this.props.usersFound;
    const usersCount = this.props.usersCount;
    const userRole = this.props.userPrivy;

    const centerText = {
      textAlign: 'center',
    };

    const regFont = {
      fontWeight: '400',
    }
    const noShow = {
      display: 'none',
    };

    const show = {
      display: 'table',
    };

    const userList = this.props.users.map(user => (
        <tr>
          <th style={regFont} className="firstName">{user.first_name}</th>
          <th style={regFont} className="lastName">{user.last_name}</th>
          <th style={regFont} className="email">{user.email}</th>
          <th style={regFont} className="sites">{this.refineUserList(user.sites).map(site => <p>{site}</p>)}</th>
        </tr>
    ));

    let userMsg;

    if (usersCount === 0) {
      userMsg = <span>No Results Found...</span>;
    } else {
      userMsg = <span>Too many results. Please refine your query and try again.</span>
    }

    return (
      <div>
        {this.redirectUser()}
        <h2>{gettext('Search users')}</h2>
        <p>{gettext('Supply one or more of the search fields to get user data from gigya.')}</p>

        <div>
          <a className="button" role="button" tabIndex="0" onClick={this.evalInputs}>{gettext('Search')}</a>
        </div>

        <table className="padded">
          <thead>
            <tr>
              <th className="medium-4">{gettext('First Name')}</th>
              <th className="medium-4">{gettext('Last Name')}</th>
              <th className="medium-4">{gettext('Email')}</th>
            </tr>
            <tr id="search_users_container">
              <th>
                <input minLength="4" type="text" className="fname" value={this.state.fname} onChange={this.handleInput} placeholder={gettext('First Name')} />
              </th>
              <th>
                <input type="text" className="lname" value={this.state.lname} onChange={this.handleInput} placeholder={gettext('Last Name')} />
              </th>
              <th>
                <input type="email" className="email" value={this.state.email} onChange={this.handleInput} placeholder={gettext('Email')} />
              </th>
            </tr>
          </thead>
        </table>
        <table style={usersLoaded && usersCount <= 25 ? show : noShow}>
          <thead>
            <tr>
              <th className="medium-2" style={centerText}>{gettext('First Name')}</th>
              <th className="medium-2" style={centerText}>{gettext('Last Name')}</th>
              <th className="medium-4" style={centerText}>{gettext('Email')}</th>
              <th className="medium-4" style={centerText}>{gettext('Site')}</th>
            </tr>
          </thead>
          <tbody>
            {userList}
          </tbody>
        </table>
        <div style={usersLoaded === false || usersCount > 25 ? show : noShow}>{userMsg}</div>
      </div>
    );
  }
}

SearchUsersPage.propTypes = {
  searchUsers: PropTypes.func.isRequired,
  results: PropTypes.func.isRequired,
  userRoles: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  usersFound: PropTypes.bool.isRequired,
  userPrivy: ImmutablePropTypes.map.isRequired,
  usersCount: PropTypes.number.isRequired,
};

export function mapStateToProps(state) {
  return {
    showingAll: Boolean((state.collections.getIn([USERS, 'filters']) || {}).show_all),
    deleteRequestState: state.requestStates.getIn([DELETE_FROM_COLLECTION, USERS]),
    userRoles: state.collections.getIn([USER_ROLES, 'items']),
    users: state.userList.users,
    userPrivy: state.loggedOnUser,
    usersFound: state.userList.usersFound,
    usersCount: state.userList.usersCount,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    searchUsers: (name, last, email) => dispatch(searchUsers(name, last, email)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchUsersPage);
